import React__default from 'react';
import { Modal } from './Modal/index.js';

function AllCategoriesModal({ show, onClose, setCategoryInput, categoryId, assetsBase, }) {
    return show ? (React__default.createElement(Modal, { categoryId: categoryId, show: show, onClose: onClose, assetsBase: assetsBase, setCategoryInput: setCategoryInput })) : null;
}

export { AllCategoriesModal };
//# sourceMappingURL=index.js.map
